<template>
  <component
    :key="item.key"
    v-bind="item.props || {}"
    :is="getComponent(item.component)"
    :value="get(item.key)"
    :data-field="item.key"
    :disabled="Boolean(item.disabled || getDisabledField(item.key))"
    @input="$ev => set(item.key, $ev)"
    :validator="validator"
    v-tooltip.bottom="item.disabled || getDisabledField(item.key)"
  >
    <template v-for="(slotItems, slot) in item.slots" v-slot:[slot]="slotScope">
      <component
        v-for="(slotItem, index) of slotItems"
        :key="item.key + slot + index"
        v-bind="{ ...slotItem.props, ...slotScope }"
        :is="getComponent(slotItem.component)"
        :value="$path('props.value', slotItem) || get(item.key)"
        :disabled="Boolean(getDisabledField(item.key))"
        @input="$ev => set(item.key, $ev)"
      />
    </template>
  </component>
</template>

<script>
import { mapGetters } from 'vuex'
import { setByPath } from '@/utils'
import { MediaComponent } from '@kvass/media'
import MediaRecommendation from '@/components/MediaRecommendation'
import MediaOnDrop from '@/components/vendors/kvass-media/onDrop'
import ColorSelector from '@kvass/custom-fields/src/Fields/ColorSelector'
import Publishing from './Publishing.vue'
import ThemeSelector from './ThemeSelector.vue'

export default {
  computed: {
    ...mapGetters('Page', ['getDisabledField']),
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    placement: {
      type: String,
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    get(key) {
      return this.$path(key, this.value)
    },
    set(key, value) {
      setByPath(key, value, this.value)
    },

    getComponent(item) {
      const items = {
        MediaComponent: MediaComponent,
        MediaRecommendation: MediaRecommendation,
        ColorSelector: ColorSelector,
        MediaOnDrop: MediaOnDrop,
        Publishing,
        ThemeSelector: ThemeSelector,
      }

      return items[item] || item
    },
  },
}
</script>

<style lang="scss"></style>
